import React, {useState, useEffect} from "react";
import {Navigate, Outlet} from "react-router";
import {useUserContext} from "../context/UserContext";

const IncompleteDocProAuth = ({allowedRoles}) => {
  const {setIsActiveDocAcc, userData} = useUserContext();
  const [userDataLocal] = useState(JSON.parse(localStorage.getItem("doctolikLoginInfo")));
  const [aciveDoctorAcc] = useState(localStorage.getItem("isAciveDoctorAcc"));

  useEffect(() => {
    // Check both localStorage and userData for is_completed
    const isCompleted = userData?.users?.is_completed || userDataLocal?.users?.is_completed;
    if (isCompleted) {
      setIsActiveDocAcc(true);
      localStorage.setItem("isAciveDoctorAcc", "1");
    } else {
      setIsActiveDocAcc(aciveDoctorAcc === "1");
    }
  }, [aciveDoctorAcc, setIsActiveDocAcc, userData, userDataLocal]);

  // Check both isAciveDoctorAcc and is_completed directly
  const isAllowed = allowedRoles.includes(userData?.users?.type || userDataLocal?.users?.type) && 
                    (aciveDoctorAcc == "1" || userData?.users?.is_completed || userDataLocal?.users?.is_completed);
  
  return isAllowed ? <Outlet /> : <Navigate to={"/doctor/profile"} replace />;
};

export default IncompleteDocProAuth;
